import { useCallback } from "react";
import { useAppSelector } from "../../../app/hooks";
import { selectPortalMe, selectPortalTargetMemberId } from "../portal-slice";
import { PORTAL_MEMBER_PARAM } from "./usePortalMember";

/** Appends the shown ward to a portal path; self needs no parameter. */
export const withPortalMember = (path: string, memberId: string | null, selfId: string | null): string =>
  memberId && memberId !== selfId
    ? `${path}${path.includes("?") ? "&" : "?"}${PORTAL_MEMBER_PARAM}=${encodeURIComponent(memberId)}`
    : path;

/** A builder that keeps the shown ward on links between portal sections. */
export const usePortalLinkBuilder = (): ((path: string) => string) => {
  const memberId = useAppSelector(selectPortalTargetMemberId);
  const selfId = useAppSelector(selectPortalMe)?.self.memberId ?? null;
  return useCallback((path: string) => withPortalMember(path, memberId, selfId), [memberId, selfId]);
};

/** The path of a portal route with the shown ward kept on it. */
export const usePortalLink = (route: string): string => usePortalLinkBuilder()(route);
